import 'react-medium-image-zoom/dist/styles.css';

import {
  CriteriaFieldValues,
  CriteriaMedia,
  CriteriaSelections,
  type GroupedOptions,
  type RatingCriteriaDetails,
  type RatingCriteriaOption,
  type RatingDamage,
  type RatingImage,
  type ScalarFieldEntry,
  type SelectedEntry,
} from '@features/buyer/jobs/criteria-option';
// import TextField from "@mui/material/TextField";
import { useEffect, useState } from 'react';

interface CriteriaOptionProps {
  ratingCriteriaOptions: RatingCriteriaOption[];
  damages?: RatingDamage[];
  ratingCriteria: RatingCriteriaDetails;
  includeCommonImages?: boolean;
  includeCriteriaNotes?: boolean;
}

const CriteriaOption = ({
  ratingCriteriaOptions,
  damages,
  ratingCriteria,
  includeCommonImages,
  includeCriteriaNotes,
}: CriteriaOptionProps): JSX.Element => {
  const [r8tingCriteriaDamageId, setR8tingCriteriaDamageId] = useState<
    Array<string | number>
  >([]);
  const [massage, setMassage] = useState('');
  const [images, setImages] = useState<RatingImage[]>([]);
  const [typeOption, setTypeOption] = useState<GroupedOptions[]>([]);
  const [typeDropdown, setTypeDropdown] = useState<GroupedOptions[]>([]);
  const [typeText, setTypeText] = useState<ScalarFieldEntry[]>([]);
  const [typeNumber, setTypeNumber] = useState<ScalarFieldEntry[]>([]);
  const [typeCheckbox, setTypeCheckbox] = useState<ScalarFieldEntry[]>([]);
  const [typeLocation, setTypeLocation] = useState<ScalarFieldEntry[]>([]);
  const [typeDate, setTypeDate] = useState<ScalarFieldEntry[]>([]);
  const [typeTime, setTypeTime] = useState<ScalarFieldEntry[]>([]);
  const [typeImages, setTypeImages] = useState<ScalarFieldEntry[]>([]);
  const [selectedOptionsArr, setSelectedOptionsArr] = useState<SelectedEntry[]>(
    []
  );
  const [selectedDropdownsArr, setSelectedDropdownArr] = useState<
    SelectedEntry[]
  >([]);
  useEffect(() => {
    const typeOptionArray: RatingCriteriaOption[] = [];
    const typeTextArray: ScalarFieldEntry[] = [];
    const typeNumberArray: ScalarFieldEntry[] = [];
    const typeDropdownArray: RatingCriteriaOption[] = [];
    const typeTimeArray: ScalarFieldEntry[] = [];
    const typeCheckboxArray: ScalarFieldEntry[] = [];
    const typeLocationArray: ScalarFieldEntry[] = [];
    const typeDateArray: ScalarFieldEntry[] = [];
    const tempImageArray: ScalarFieldEntry[] = [];
    const allOptionsArr: GroupedOptions[] = [];
    const allDropDownArr: GroupedOptions[] = [];
    if (ratingCriteria) {
      for (let i = 0; i < ratingCriteriaOptions.length; i++) {
        if (ratingCriteriaOptions[i].type === 'Option') {
          typeOptionArray.push(ratingCriteriaOptions[i]);
        }
        if (ratingCriteriaOptions[i].type === 'DropDown') {
          typeDropdownArray.push(ratingCriteriaOptions[i]);
        }
        if (ratingCriteriaOptions[i].type === 'text') {
          const data = {
            ratingTitle: ratingCriteriaOptions[i].ratingTitle,
            id: ratingCriteriaOptions[i].id,
            ratingCriteriaUserId:
              ratingCriteriaOptions[i].ratingCriteriaUser?.id,
            value: {
              value: ratingCriteriaOptions[i].ratingCriteriaUser?.value?.value,
            },
          };
          typeTextArray.push(data);
        }
        if (ratingCriteriaOptions[i].type === 'Number') {
          const data = {
            ratingTitle: ratingCriteriaOptions[i].ratingTitle,
            id: ratingCriteriaOptions[i].id,
            ratingCriteriaUserId:
              ratingCriteriaOptions[i].ratingCriteriaUser?.id,
            value: {
              value: ratingCriteriaOptions[i].ratingCriteriaUser?.value?.value,
            },
          };
          typeNumberArray.push(data);
        }
        if (ratingCriteriaOptions[i].type === 'Checkbox') {
          const data = {
            ratingTitle: ratingCriteriaOptions[i].ratingTitle,
            id: ratingCriteriaOptions[i].id,
            ratingCriteriaUserId:
              ratingCriteriaOptions[i].ratingCriteriaUser?.id,
            value: {
              value: ratingCriteriaOptions[i].ratingCriteriaUser?.value?.value,
            },
          };
          typeCheckboxArray.push(data);
        }
        if (ratingCriteriaOptions[i].type === 'Date') {
          const data = {
            ratingTitle: ratingCriteriaOptions[i].ratingTitle,
            id: ratingCriteriaOptions[i].id,
            ratingCriteriaUserId:
              ratingCriteriaOptions[i].ratingCriteriaUser?.id,
            value: {
              value: ratingCriteriaOptions[i].ratingCriteriaUser?.value?.value,
            },
          };
          typeDateArray.push(data);
        }
        if (ratingCriteriaOptions[i].type === 'Time') {
          const data = {
            ratingTitle: ratingCriteriaOptions[i].ratingTitle,
            id: ratingCriteriaOptions[i].id,
            ratingCriteriaUserId:
              ratingCriteriaOptions[i].ratingCriteriaUser?.id,
            value: {
              value: ratingCriteriaOptions[i].ratingCriteriaUser?.value?.value,
            },
          };
          typeTimeArray.push(data);
        }
        if (ratingCriteriaOptions[i].type === 'Location') {
          const data = {
            ratingTitle: ratingCriteriaOptions[i].ratingTitle,
            id: ratingCriteriaOptions[i].id,
            ratingCriteriaUserId:
              ratingCriteriaOptions[i].ratingCriteriaUser?.id,
            value: {
              value: ratingCriteriaOptions[i].ratingCriteriaUser?.value?.value,
            },
          };
          typeLocationArray.push(data);
        }
        if (ratingCriteriaOptions[i].type === 'Image') {
          // typeImageArray.push(ratingCriteriaOptions[i])
          const data = {
            ratingTitle: ratingCriteriaOptions[i].ratingTitle,
            id: ratingCriteriaOptions[i].id,
            ratingCriteriaUserId:
              ratingCriteriaOptions[i].ratingCriteriaUser?.id,
            value: {
              value: ratingCriteriaOptions[i].ratingCriteriaUser?.value?.value,
            },
          };
          tempImageArray.push(data);
        }
      }
      if (typeOptionArray?.length > 0) {
        const parentOptions = typeOptionArray.filter(
          (el) => el.headingId == null
        );
        const selectedOptionsArrTemp = [...selectedOptionsArr];
        for (let i = 0; i < parentOptions.length; i++) {
          let ratingCriteriaUserId: string | number | null | undefined = null;
          const parentOption = parentOptions[i];

          if (parentOption.ratingCriteriaUser) {
            ratingCriteriaUserId = parentOption.ratingCriteriaUser.id;

            selectedOptionsArrTemp.push({
              id: parentOption.id,
              ratingCriteriaUserId: parentOption.ratingCriteriaUser.id,
              value: { value: true },
            });
          }
          const childOptions = typeOptionArray.filter(
            (el) => el.headingId === parentOptions[i].id
          );
          if (!ratingCriteriaUserId) {
            const childOptionHavingRatingCriteriaUser = childOptions.find(
              (el) => el.ratingCriteriaUser?.value
            );
            if (childOptionHavingRatingCriteriaUser) {
              ratingCriteriaUserId =
                childOptionHavingRatingCriteriaUser?.ratingCriteriaUser?.id;
              selectedOptionsArrTemp.push({
                id: childOptionHavingRatingCriteriaUser.id,
                ratingCriteriaUserId:
                  childOptionHavingRatingCriteriaUser?.ratingCriteriaUser?.id,
                value: { value: true },
              });
            }
          }
          childOptions.unshift(parentOptions[i]);
          allOptionsArr.push({
            heading: parentOptions[i].heading,
            ratingCriteriaUserId: ratingCriteriaUserId ?? null,
            options: childOptions,
          });
        }
        setSelectedOptionsArr(selectedOptionsArrTemp);
      }

      if (typeDropdownArray?.length > 0) {
        const parentDropdown = typeDropdownArray.filter(
          (el) => el.headingId == null
        );
        const selectedDropdownArrTemp = [...selectedDropdownsArr];
        for (let i = 0; i < parentDropdown.length; i++) {
          let ratingCriteriaUserId: string | number | null | undefined = null;
          const parentDropdownItem = parentDropdown[i];
          if (parentDropdownItem.ratingCriteriaUser) {
            ratingCriteriaUserId = parentDropdownItem.ratingCriteriaUser.id;

            selectedDropdownArrTemp.push({
              id: parentDropdownItem.id,
              ratingCriteriaUserId: parentDropdownItem.ratingCriteriaUser.id,
              ratingValue: parentDropdownItem.ratingValue,
              value: { value: true },
            });
          }
          const childDropdown = typeDropdownArray.filter(
            (el) => el.headingId === parentDropdown[i].id
          );
          if (!ratingCriteriaUserId) {
            const childOptionHavingRatingCriteriaUser = childDropdown.find(
              (el) => el.ratingCriteriaUser?.value
            );
            if (childOptionHavingRatingCriteriaUser) {
              ratingCriteriaUserId =
                childOptionHavingRatingCriteriaUser?.ratingCriteriaUser?.id;
              selectedDropdownArrTemp.push({
                id: childOptionHavingRatingCriteriaUser.id,
                ratingCriteriaUserId:
                  childOptionHavingRatingCriteriaUser?.ratingCriteriaUser?.id,
                ratingValue: childOptionHavingRatingCriteriaUser.ratingValue,
                value: { value: true },
              });
            }
          }
          childDropdown.unshift(parentDropdown[i]);
          allDropDownArr.push({
            heading: parentDropdown[i].heading,
            ratingCriteriaUserId: ratingCriteriaUserId ?? null,
            options: childDropdown,
          });
        }
        setSelectedDropdownArr(selectedDropdownArrTemp);
      }

      setTypeOption(allOptionsArr);
      setTypeDropdown(allDropDownArr);
      setTypeText(typeTextArray);
      setTypeNumber(typeNumberArray);
      setTypeCheckbox(typeCheckboxArray);
      setTypeDate(typeDateArray);
      setTypeTime(typeTimeArray);
      setTypeLocation(typeLocationArray);
      setTypeImages(tempImageArray);
      setImages(ratingCriteria.images ?? []);
      setMassage(ratingCriteria.criteriaInfo ?? '');
      setR8tingCriteriaDamageId(ratingCriteria.damageIds ?? []);
    }
  }, [ratingCriteria]);

  return (
    <div>
      <CriteriaSelections
        r8tingCriteriaDamageId={r8tingCriteriaDamageId}
        damages={damages}
        hasOptions={ratingCriteria.hasOptions}
        typeOption={typeOption}
        selectedOptionsArr={selectedOptionsArr}
      />
      <CriteriaFieldValues
        selectedDropdownsArr={selectedDropdownsArr}
        typeDropdown={typeDropdown}
        typeText={typeText}
        typeNumber={typeNumber}
        typeDate={typeDate}
        typeTime={typeTime}
        typeLocation={typeLocation}
        typeCheckbox={typeCheckbox}
      />
      {/* {} */}
      <CriteriaMedia
        typeImages={typeImages}
        includeCommonImages={includeCommonImages}
        images={images}
        includeCriteriaNotes={includeCriteriaNotes}
        massage={massage}
      />
    </div>
  );
};

export default CriteriaOption;
